module.exports = __webpack_public_path__ + "static/media/debraAmar.2cbc258c.jpg";